//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { mapState } from 'vuex'
    import dummyItem from '~/components/content/dummy/video_dummy.vue'

    export default {
      async fetch() {
        await this.$store.dispatch('resourcesStore/getResources', this.queries.mostRecent)
    },
    components: {
        dummyItem
    },
    data() { 
        return {
            backEnd: true,
            forwardEnd: false,
        };
    },
    computed: {
        ...mapState({
            queries: ({ resourcesStore: {queries} }) => queries,
            mostRecent: ({ resourcesStore: {mostRecent} }) => mostRecent,
            loading: ({ resourcesStore: {loading} }) => loading
        }),
    }
}
